export default __webpack_public_path__ + "static/media/mbfcTower.jpg?.c966d61e";